import type { Dispatch, FC, PropsWithChildren, SetStateAction } from 'react';
import { createContext, useContext, useMemo, useState } from 'react';

export interface PbsContentContext {
  isShown: boolean;
  setIsShown: Dispatch<SetStateAction<boolean>>;
}

export const pbsContentContext = createContext<PbsContentContext | undefined>(undefined);

const { Provider } = pbsContentContext;

export const PbsContentProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isShown, setIsShown] = useState(false);
  const value = useMemo(() => ({ isShown, setIsShown }), [isShown, setIsShown]);

  return <Provider value={value}>{children}</Provider>;
};

export const usePbsContent = () => {
  const context = useContext(pbsContentContext);
  if (context) {
    return context;
  }
  throw new Error('usePbsContentContext must be used within a PbsContentProvider.');
};
